/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ActivityArea } from './';
import {
    ActivityAreaFromJSON,
    ActivityAreaFromJSONTyped,
    ActivityAreaToJSON,
} from './';
import type { PostalAddress } from './';
import {
    PostalAddressFromJSON,
    PostalAddressFromJSONTyped,
    PostalAddressToJSON,
} from './';

/**
 * 
 * @export
 * @interface WorkExperience
 */
export interface WorkExperience {
    /**
     * 
     * @type {string}
     * @memberof WorkExperience
     */
    id: string;
    /**
     * 
     * @type {boolean}
     * @memberof WorkExperience
     */
    imported: boolean;
    /**
     * 
     * @type {string}
     * @memberof WorkExperience
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkExperience
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkExperience
     */
    clientCompanyName?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkExperience
     */
    clientCompanyId?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkExperience
     */
    clientCompanyOrganizationId?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkExperience
     */
    logoUrl?: string;
    /**
     * 
     * @type {ActivityArea}
     * @memberof WorkExperience
     */
    activityArea?: ActivityArea;
    /**
     * 
     * @type {Date}
     * @memberof WorkExperience
     */
    startDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof WorkExperience
     */
    endDate?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof WorkExperience
     */
    asFreelancer: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WorkExperience
     */
    currentJob: boolean;
    /**
     * 
     * @type {PostalAddress}
     * @memberof WorkExperience
     */
    location?: PostalAddress;
}

/**
 * Check if a given object implements the WorkExperience interface.
 */
export function instanceOfWorkExperience(value: object): value is WorkExperience {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('imported' in value) || value['imported'] === undefined) return false;
    if (!('asFreelancer' in value) || value['asFreelancer'] === undefined) return false;
    if (!('currentJob' in value) || value['currentJob'] === undefined) return false;
    return true;
}

export function WorkExperienceFromJSON(json: any): WorkExperience {
    return WorkExperienceFromJSONTyped(json, false);
}

export function WorkExperienceFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkExperience {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'imported': json['imported'],
        'title': json['title'] == null ? undefined : json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'clientCompanyName': json['clientCompanyName'] == null ? undefined : json['clientCompanyName'],
        'clientCompanyId': json['clientCompanyId'] == null ? undefined : json['clientCompanyId'],
        'clientCompanyOrganizationId': json['clientCompanyOrganizationId'] == null ? undefined : json['clientCompanyOrganizationId'],
        'logoUrl': json['logoUrl'] == null ? undefined : json['logoUrl'],
        'activityArea': json['activityArea'] == null ? undefined : ActivityAreaFromJSON(json['activityArea']),
        'startDate': json['startDate'] == null ? undefined : (new Date(json['startDate'])),
        'endDate': json['endDate'] == null ? undefined : (new Date(json['endDate'])),
        'asFreelancer': json['asFreelancer'],
        'currentJob': json['currentJob'],
        'location': json['location'] == null ? undefined : PostalAddressFromJSON(json['location']),
    };
}

export function WorkExperienceToJSON(value?: WorkExperience | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'imported': value['imported'],
        'title': value['title'],
        'description': value['description'],
        'clientCompanyName': value['clientCompanyName'],
        'clientCompanyId': value['clientCompanyId'],
        'clientCompanyOrganizationId': value['clientCompanyOrganizationId'],
        'logoUrl': value['logoUrl'],
        'activityArea': ActivityAreaToJSON(value['activityArea']),
        'startDate': value['startDate'] == null ? undefined : ((value['startDate']).toISOString().substring(0,10)),
        'endDate': value['endDate'] == null ? undefined : ((value['endDate']).toISOString().substring(0,10)),
        'asFreelancer': value['asFreelancer'],
        'currentJob': value['currentJob'],
        'location': PostalAddressToJSON(value['location']),
    };
}

